import Banner from "@/components/Banner";
import { useNavigate } from "react-router-dom";
import { FormValues } from "../../activity-types/[activityTypeId]/_form/validation/schema";
import { useFormContext } from "react-hook-form";

interface EventAssociationBannerProps {
  className?: string;
}

function transformFormValues(formValues: FormValues) {
  return {
    title: formValues?.title,
    description: formValues?.activityDescription,
    eventType: formValues?.activityType,
    section: {
      name: formValues?.section,
      id: formValues?.sectionId
    }
  };
}
export default function EventAssociationBanner({ className }: EventAssociationBannerProps) {
  const { watch } = useFormContext<FormValues>();
  const formValues = watch();
  const navigate = useNavigate();

  return (
    <Banner
      variant="info"
      inline={true}
      description="This activity type can have associated events. If you want to publish the activity and collect registrations, create an event directly."
      primaryAction={{
        label: "Create Event",
        onClick: () => {
          navigate("/activities/events/new?return_to=" + location.pathname, {
            state: { event: transformFormValues(formValues), isCopy: false }
          });
        },
        isInternal: true
      }}
      hideSecondaryDismiss
      className={className}
    />
  );
}
